import { render, staticRenderFns } from "./TransitionHeight.vue?vue&type=template&id=0928966a&scoped=true&"
import script from "./TransitionHeight.vue?vue&type=script&lang=js&"
export * from "./TransitionHeight.vue?vue&type=script&lang=js&"
import style0 from "./TransitionHeight.vue?vue&type=style&index=0&id=0928966a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0928966a",
  null
  
)

export default component.exports